import { Dispatch, SetStateAction } from "react";

export enum LatestWorkerMovement {
  MOVING = "MOVING",
  STATIONARY = "STATIONARY",
  UNKNOWN = "UNKNOWN",
}

export interface ITripResponseType {
  id: string;
  workerUserId: string;
  shiftId: string;
  facilityId: string;
  radarTripId: string;
  currentEtaDuration: number;
  currentEtaDistance: number;
  initialEtaDuration: number;
  initialEtaDistance: number;
  latestWorkerMovement: LatestWorkerMovement;
  status: TripStatus;
  isLate: boolean;
  startTime: string;
  stopTime: string | undefined;
  receivedAt: string;
  createdAt: string;
  updatedAt: string;
  workerInputtedEta?: string;
}

export interface NewTripResponse {
  id: string;
  type: "trip";
  attributes: {
    isLate: boolean;
    workerId: string;
    workplaceId: string;
    status: NewTripStatus;
    currentLatitude?: number;
    currentLongitude?: number;
    currentEtaDuration: number;
    currentEtaDistance: number;
    initialEtaDuration: number;
    initialEtaDistance: number;
    latestWorkerMovement: LatestWorkerMovement;
    shiftId: string;
    locationProviderTripId?: string;
    tripStartTime: string;
    tripStopTime?: string;
    lastLocationReceivedByServerAt: string;
    createdAt: string;
    updatedAt: string;
    workerDeclaredEta?: string;
  };
}

export type NewTripStatus =
  | "TRIP_PLACEHOLDER"
  | "TRIP_PENDING"
  | "TRIP_STARTED"
  | "TRIP_APPROACHING"
  | "TRIP_ARRIVED"
  | "TRIP_COMPLETED"
  | "TRIP_CANCELLED"
  | "TRIP_EXPIRED";

export enum TripStatus {
  // Trip not started
  TRIP_PENDING = "TRIP_PENDING",

  // trip ongoing
  TRIP_STARTED = "TRIP_STARTED",
  TRIP_APPROACHING = "TRIP_APPROACHING",

  // Trip finished
  TRIP_ARRIVED = "TRIP_ARRIVED",
  TRIP_COMPLETED = "TRIP_COMPLETED",

  // No information
  TRIP_CANCELLED = "TRIP_CANCELLED",
  TRIP_EXPIRED = "TRIP_EXPIRED",

  TRIP_NO_INFORMATION = "TRIP_NO_INFORMATION",
}

export enum StepStatus {
  ERROR = "error",
  FINISHED = "finish",
  PROCESS = "process",
  WAIT = "wait",
}

export interface IWorkerETACardProps {
  setWorkerETA: Dispatch<SetStateAction<string>>;
  setWorkerIsLate: Dispatch<SetStateAction<boolean>>;
  agentId: string;
  end: string;
  tmz: string;
  shiftId: string;
}

export interface DescriptionText {
  ongoing: DescriptionTextItem;
  ongoingLate: DescriptionTextItem;
  approaching: DescriptionTextItem;
  approachingLate: DescriptionTextItem;
  finished: DescriptionTextItem;
}

export interface DescriptionTextItem {
  title: string | null;
  description: string | null;
}

export interface StyledTitleProps {
  late?: boolean;
}
